module.exports = __webpack_public_path__ + "static/media/hyttemer.833de67a.svg";